<tbody aria-live="polite" {...$$restProps}>
  <slot />
</tbody>
